/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddDomainRequest
 */
export interface AddDomainRequest {
    /**
     * 
     * @type {string}
     * @memberof AddDomainRequest
     */
    title?: string;
}

/**
 * Check if a given object implements the AddDomainRequest interface.
 */
export function instanceOfAddDomainRequest(value: object): value is AddDomainRequest {
    return true;
}

export function AddDomainRequestFromJSON(json: any): AddDomainRequest {
    return AddDomainRequestFromJSONTyped(json, false);
}

export function AddDomainRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDomainRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
    };
}

  export function AddDomainRequestToJSON(json: any): AddDomainRequest {
      return AddDomainRequestToJSONTyped(json, false);
  }

  export function AddDomainRequestToJSONTyped(value?: AddDomainRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
    };
}

